var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26910_26140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 1.33301H3.99935C3.26602 1.33301 2.66602 1.93301 2.66602 2.66634V13.333C2.66602 14.0663 3.26602 14.6663 3.99935 14.6663H11.9993C12.7327 14.6663 13.3327 14.0663 13.3327 13.333V2.66634C13.3327 1.93301 12.7327 1.33301 11.9993 1.33301ZM3.99935 2.66634H7.33268V7.99967L5.66601 6.99967L3.99935 7.99967V2.66634Z",
    fill: "#9D9DE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26910_26140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjectIcon);
export default __webpack_public_path__ + "static/media/subject-icon.b24a667b.svg";
export { ForwardRef as ReactComponent };